<template>     
<v-container class="menupage flex" fill-height>
    <v-slide-y-transition mode="out-in">                            
        <v-layout class="home flex w-full justify-center" align-center wrap :style="homeStyle">                       
            <v-card v-if="accesHomePilot.visible" tile :hover="accesHomePilot.enable"  class="item" :class="{disabled:!accesHomePilot.enable}"  :to="accesHomePilot.enable?{name:'Pilot'}:null" width="300">
              <v-img contain :src="require('@/assets/glider.jpg')" height="200"></v-img>
              <v-card-title primary-title  style="background-color:#4066aa;color:#fff">
                <div>
                  <h3 class="headline mb-0">{{$t('Home.PilotTitle')}}</h3>
                  <div>{{$t('Home.PilotSubTitle')}}</div>
                </div>
              </v-card-title>
            </v-card>            
             <!-- BLF037 : tuile Flotte seulement si le module est accessible (RG-ACC-051) -->
             <v-card v-if="accesHomePilot.visible && hasFleetModule" tile :hover="accesHomePilot.enable" class="item" :class="{disabled:!accesHomePilot.enable}"  :to="accesHomePilot.enable?{name:'Fleet'}:null" width="300">
              <v-img contain :src="require('@/assets/fleet.jpg')"  height="200"></v-img>
              <v-card-title primary-title style="background-color:#4066aa;color:#fff">
                <div>
                  <h3 class="headline mb-0">{{$t('Home.FleetTitle')}}</h3>
                  <div>{{$t('Home.FleetSubTitle')}}</div>
                </div>
              </v-card-title>
            </v-card>       
            <v-card v-if="accesHomeViewData.visible" tile :hover="accesHomeViewData.enable" class="item" :class="{disabled:!accesHomeViewData.enable}"  :to="accesHomeViewData.enable?{name:'Pilot'}:null" width="300">
              <v-img contain :src="require('@/assets/StarategicInvestmentAnalysis_0.png')"  height="200"></v-img>
              <v-card-title primary-title style="background-color:#4066aa;color:#fff">
                <div>
                  <h3 class="headline mb-0">{{$t('Home.ViewDataTitle')}}</h3>
                  <div>{{$t('Home.ViewDataSubTitle')}}</div>
                </div>
              </v-card-title>
            </v-card>              
            <v-card v-if="accesHomeMaintenance.visible" tile :hover="accesHomeMaintenance.enable" class="item" :class="{disabled:!accesHomeMaintenance.enable}"  :to="accesHomeMaintenance.enable?{name:'Maintenance'}:null" width="300">
              <v-img contain :src="require('@/assets/sea-explorer-interchangeable-payloads.png')"  height="200"></v-img>
              <v-card-title primary-title  style="background-color:#00C853;color:#fff">
                <div>
                  <h3 class="headline mb-0">{{$t('Home.MaintenaceTitle')}}</h3>
                  <div>{{$t('Home.MaintenaceSubTitle')}}</div>
                </div>
              </v-card-title>
            </v-card>   
            <v-card v-if="accesHomeSmartPlanning.visible && hasSmartPlanningModule" tile :hover="accesHomeSmartPlanning.enable" class="item" :class="{disabled:!accesHomeSmartPlanning.enable}"  :to="accesHomeSmartPlanning.enable?{name:'SmartPlanning'}:null" width="300">
              <v-img contain :src="require('@/assets/smart-planning.jpg')"  height="200"></v-img>
              <v-card-title primary-title style="background-color:#FB8C00;color:#fff">
                <div>
                  <h3 class="headline mb-0">{{$t('Home.SmartPlanning')}}</h3>
                  <div>{{$t('Home.SmartPlanningSubTitle')}}</div>
                </div>
              </v-card-title>
            </v-card>            
            <!-- <v-card v-if="accesHomeMissionPlanning.visible" tile :hover="accesHomeMissionPlanning.enable" class="item" :class="{disabled:!accesHomeMissionPlanning.enable}"  :to="accesHomeMissionPlanning.enable?{name:'NewMissionPlanTemplate'}:null" width="300">
              <v-img contain :src="require('@/assets/services-seo-optimized.png')"  height="200"></v-img>
              <v-card-title primary-title style="background-color:#FB8C00;color:#fff">
                <div>
                  <h3 class="headline mb-0">{{$t('Home.MissionPlanning')}}</h3>
                  <div>{{$t('Home.MissionPlanningSubTitle')}}</div>
                </div>
              </v-card-title>
            </v-card>               -->
            <v-card v-if="accesHomeAdministration.visible" tile :hover="accesHomeAdministration.enable" class="item" :class="{disabled:!accesHomeAdministration.enable}"  :to="accesHomeAdministration.enable?{name:'Configuration'}:null" width="300">
                <v-img contain :src="require('@/assets/admin.png')"  height="200"></v-img>
                <v-card-title primary-title style="background-color:#00C853;color:#fff">
                  <div>
                    <h3 class="headline mb-0">{{$t('Home.Configuration')}}</h3>
                    <div>{{$t('Home.ConfigurationSubTitle')}}</div>
                  </div>
                </v-card-title>
            </v-card>                     
      </v-layout>
    </v-slide-y-transition>
</v-container>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { SecurityItemsKeys } from '../enum/SecurityItems'
import { HomeImagesConfig } from '@/models/datapool/HomeImagesConfig'
import { DataPoolGlobalKeys } from '@/enum/DataPool'

@Component({
  name: 'Home'  
})
export default class Home extends Vue {  
      
  mounted(){
    this.$vuetify.theme.primary = '#4066aa'
    this.$vuetify.theme.secondary = '#ec7404'    
  }

   get userSecurity(){
     return this.$store.myGetters.userSecurity
   }

   get accesHomePilot() {
     return this.userSecurity[SecurityItemsKeys.HOME_PILOT]
   }

   get accesHomeMaintenance() {     
     return this.userSecurity[SecurityItemsKeys.HOME_MAINTENANCE]
   }

   get accesHomeViewData() {
     return this.userSecurity[SecurityItemsKeys.HOME_VIEW_DATA]
   }
   
   get accesHomeMissionPlanning() {
     return this.userSecurity[SecurityItemsKeys.HOME_MISSION_PLANNING]
   }

   get accesHomeSmartPlanning() {
     return this.userSecurity[SecurityItemsKeys.HOME_SMART_PLANNING]
   }


   // BLF037 — modules activés par enseigne (RG-ACC-051)
   get hasFleetModule() {
     return this.$store.myGetters.hasFleetModule
   }

   get hasSmartPlanningModule() {
     return this.$store.myGetters.hasSmartPlanningModule
   }

   get accesHomeAdministration() {
     return this.userSecurity[SecurityItemsKeys.HOME_ADMINISTRATION]
   }

   // Quatre tuiles ou moins : deux par ligne (tuile 300px + marges 2 × 10px).
   get visibleTileCount(): number {
     return [
       this.accesHomePilot?.visible,
       this.accesHomePilot?.visible && this.hasFleetModule,
       this.accesHomeViewData?.visible,
       this.accesHomeMaintenance?.visible,
       this.accesHomeSmartPlanning?.visible && this.hasSmartPlanningModule,
       this.accesHomeAdministration?.visible,
     ].filter(Boolean).length
   }

   get homeStyle() {
     return this.visibleTileCount <= 4 ? { maxWidth: '640px' } : undefined
   }

   

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home{
  max-width: 960px;
  max-height: 640px;
  margin: auto;  
}
.item{
  margin:10px;
  opacity: 0.8;
}
.item:hover{  
  opacity: 1;
}
.disabled::after{
  content:'';
  position: absolute;
  top:0px;
  left:0px;
  width:100%;
  height:100%;
  background-color: rgba(0,0,0,0.5);
  cursor: initial;
}
.menupage{
  overflow: auto;  
}
</style>
